import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    ButtonSet,
} from '@indeed/ifl-components';
import useGettext from '../../util/GettextFactory';

interface ExitDialogProps {
    isOpen: boolean;
    onExitClick: () => void;
    onCancelClick: () => void;
}

const ExitDialog: React.FC<ExitDialogProps> = ({ isOpen, onExitClick, onCancelClick }) => {
    const gt = useGettext();

    return (
        <Dialog
            open={isOpen}
            onOpenChange={(open) => {
                if (!open) {
                    onCancelClick();
                }
            }}
            size="sm"
            type="dialog"
        >
            <DialogContent>
                <DialogHeader labelClose={gt.gettext('Close')}>
                    {gt.gettext('Are you sure you want to exit?')}
                </DialogHeader>
                <DialogBody>
                    {gt.gettext('You can finish setting up Auto Apply anytime.')}
                </DialogBody>
                <DialogFooter>
                    <ButtonSet>
                        <Button variant="tertiary" size="md" onClick={onCancelClick}>
                            {gt.gettext('Continue')}
                        </Button>
                        <Button variant="primary" size="md" onClick={onExitClick}>
                            {gt.gettext('Exit')}
                        </Button>
                    </ButtonSet>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ExitDialog;
